import React from "react";
import "../../styles/SalesFunnel.css";
import { Link } from "react-router-dom";
import Brservice from "../../Page-section/branding/Brservice";
import Faq from "../../Page-section/branding/Faq";
import Portfolio from "../../components/portfolio";

import {
  FaLightbulb,
  FaUsers,
  FaCode,
  FaCogs,
  FaAward,
} from "react-icons/fa";

const brprocess = () => {
  const points = [
    "	Builds trust and credibility ",
    "Improves purchaser reputation ",
    "Enhances advertising and marketing performance ",
    "Creates emotional reference to customers",
    "Drives long-term business growth",
  ];
  const point = [
    "Proven track record ",
    "High-quality creative solutions  ",
    "Client-focused approach  ",
    "Affordable pricing ",
    "Dedicated support ",
  ];

  const steps = [
    {
      id: 1,
      title: "Research & Analysis",
      color: "green",

      icon: <FaLightbulb />,
      desc: "We understand your enterprise, audience, and competition.",
    },
    {
      id: 2,
      title: "Strategy Development",
      color: "#0868a0",
      icon: <FaUsers />,
      desc: "As a innovative organisation in Noida, we create a customized branding method.",
    },
    {
      id: 3,
      title: "Design & Development",
      color: "green",
      icon: <FaCode />,
      desc: "We awareness on super brand and emblem identification design together with internet site improvement.",
    },
    {
      id: 4,
      title: "Testing & Launch",
      color: "#0868a0",
      icon: <FaCogs />,
      desc: "We make certain everything is optimized earlier than launch.",
    },
    {
      id: 5,
      title: "Continuous Support",
      color: "green",
      icon: <FaAward />,
      desc: "Being one of the top internet development organizations in noida, we provide ongoing guide and updates. ",
    },
  ];
  return (
    <section className="sf-wrapper">
      <div className="sf-sidebar">
        <div className="sf-card">
          <h2>Our Services</h2>

          <ul className="sf-service-list">
              <li className="active">
              <Link to="/branding-agency-noida">Branding Services</Link>
            </li>
            <li>
              <Link to="/web-development-company-in-noida">Web Development</Link>
            </li>
            <li>
              <Link to="/web-design-services">Web Design</Link>
            </li>
            <li>
              <Link to="/seo-agency-noida">SEO Services</Link>
            </li>
            <li>
              <Link to="/content-marketing-services">Content Marketing</Link>
            </li>
               <li>
              <Link to="/social-media-marketing-services">Social Media Marketing</Link>
            </li>
            <li>
              <Link to="/ai-automation-services">
                AI Automation Services
              </Link>
            </li>
          
            <li>
              <Link to="/lead-generation-services">Lead Generation</Link>
            </li>
            <li>
              <Link to="/sales-funnel-optimization">
                Sales Funnel Optimization
              </Link>
            </li>
          
            <li>
              <Link to="/business-automation-services">
                Business Automation
              </Link>
            </li>
            <li>
              <Link to="/resources">Resources</Link>
            </li>
          </ul>
        </div>

        <div className="sf-card">
          <h2>Contact Info</h2>

          <div className="sf-contact">
            <p>Address :- Sector-62, Noida, India</p>
            <p>
              Phone :- <br />
              <a href="tel:+919315020291"> +91 9315020291</a> 
            </p>
            <p>
              Email :- <br />
              <a href="mailto:connect@empowerweb.in">connect@empowerweb.in</a>
            </p>
          </div>
        </div>
                <Portfolio />

      </div>
      <div className="sf-main-content">
        <section className="why-container">
          <div className="why-content">
            <h2>Why Branding is Important for Your Business</h2>

            <p>
              Branding is greater than only a emblem it's far the complete
              experience your customers have along with your business. A strong
              logo builds credibility, improves reputation, and increases client
              loyalty. Partnering with <b>top creative agency in Noida</b>{" "}
              permits you to create a completely unique logo identity that
              resonates together with your audience.
            </p>

            <ul>
              {points.map((item, index) => (
                <li key={index}>
                  <span className="check">✔</span> {item}
                </li>
              ))}
            </ul>

            <p>
              With the right logo and logo identification design, your business
              can create an enduring influence within the minds of customers.
            </p>
          </div>
        </section>
        <section className="freight-container">
          <div className="freight-content">
            <h3>What Makes Us Different?</h3>
            <p>
              Choosing the proper Branding Agency in Noida could make a large
              distinction in your business boom. Here’s what sets us aside:
            </p>
            <div className="freight-boxes">
              <div className="box">
                <div>
                  <h4>Creative Excellence</h4>
                  <br />
                </div>
              </div>
              <div className="box">
                <div>
                  <h4>Customized Solutions</h4>
                </div>
              </div>
              <div className="box">
                <div>
                  <h4>Experienced Team</h4>
                </div>
              </div>
            </div>
            <div className="freight-boxes">
              <div className="box">
                <div>
                  <h4>Affordable Pricing</h4>
                  <br />
                </div>
              </div>
              <div className="box">
                <div>
                  <h4>Result-Driven Approach</h4>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Brservice />
        <section className="work-process-section">
          <h3 className="work-title">Our Branding Process</h3>
          <p className="work-subtitle">
            We follow a structured method to supply the high-quality results:
          </p>

          <div className="process-wrapper">
            {/* STEP LABELS */}
            <div className="process-line">
              {steps.map((step) => (
                <div
                  key={step.id}
                  className="process-step"
                  style={{ backgroundColor: step.color }}
                >
                  {step.title}
                </div>
              ))}
            </div>

            {/* STEP DETAILS */}
            <div className="process-grid">
              {steps.map((step) => (
                <div className="process-item" key={step.id}>
                  <div
                    className="process-iconv"
                    style={{ borderColor: step.color, color: step.color }}
                  >
                    {step.icon}
                  </div>
                  <h3 className="process-num" style={{ color: step.color }}>
                    {step.id.toString().padStart(2, "0")}
                  </h3>
                  <p className="process-text">{step.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="why-container">
          <div className="why-content">
            <h2>Why Choose Us?</h2>

            <p>
              There are many options to be had, however selecting the right
              Branding Agency in Noida is crucial for fulfillment. Here’s why
              businesses consider us:
            </p>

            <ul>
              {point.map((item, index) => (
                <li key={index}>
                  <span className="check">✔</span> {item}
                </li>
              ))}
            </ul>

            <p>
              As a leading pinnacle innovative organization in Noida, we ensure
              your emblem achieves maximum impact.
            </p>
          </div>
        </section>
        <section className="benefits-section">
          <div className="container">
            <div className="header">
              <div className="title-row">
                <h3>Benefits of Choosing Our Branding Services</h3>

                <p>
                  Our information in <b>logo and brand identity design</b> that your
                  emblem communicates effectively together with your target
                  market. Working with a professional Branding Agency in Noida
                  offers more than one advantages:
                </p>
              </div>
            </div>

            <div className="cards">
              <div className="card">
                <h3>Strong logo identity </h3>
              </div>
              <div className="card">
                <h3>Better client engagement </h3>
              </div>
              <div className="card">
                <h3>Increased logo visibility </h3>
              </div>
              <div className="card">
                <h3>Higher conversion quotes </h3>
              </div>
              <div className="card">
                <h3>Improved business credibility </h3>
              </div>
            </div>
          </div>
        </section>
        <Faq />
        <section className="operations-wrapper">
          <div className="operations-left">
            <h3>Get Started with the Branding Agency in Noida</h3>
          </div>
          <div className="operations-right">
              <p>
                If you want to construct a strong and memorable emblem, it’s
                time to accomplice with a relied on Branding Agency in Noida.
                Our crew is ready to help you create a completely unique
                identification that units you aside from the competition.
              </p>
          </div>
        </section>
      </div>
    </section>
  );
};

export default brprocess;
